import React, { Fragment, Component } from 'react';
import PropTypes from 'prop-types';
import AddressForm from '../AddressForm';
import Select2 from '../Select2';
import Cleave from 'cleave.js/dist/cleave-react';
import BENEFICIARY_RELATIONSHIPS from '../../constants/beneficiaryRelationships';
import './BeneficiaryForm.css';

const propTypes = {
  beneficiary: PropTypes.object,
  client: PropTypes.object,
  onChange: PropTypes.func,
};

class BeneficiaryForm extends Component {
  handlePhoneInit = (cleave) => {
    this.cleave = cleave;
    cleave.setRawValue(this.props.beneficiary.phone_number);
  };

  reset = () => {
    this.cleave.setRawValue('');
  };

  render() {
    const { client, beneficiary, onChange } = this.props;

    return (
      <Fragment>
        <p className="m-b-20">
          Please supply all required information to successfully add a
          beneficiary to your policy.
        </p>
        <div className="form-group row">
          <label className="col-md-3 text-uppercase">Beneficiary details</label>
          <div className="col-md-9 p-l-30">
            <div className="form-group">
              <label htmlFor="relationship" className="text-uppercase">
                Relationship to {client.person.first_name}
              </label>
              <Select2
                className="form-control"
                id="relationship"
                name="relationship_description"
                value={beneficiary.relationship_description || ''}
                placeholder="Select one"
                aria-required="true"
                required
                onChange={onChange}
              >
                {BENEFICIARY_RELATIONSHIPS.map((relationship) => (
                  <option value={relationship} key={relationship}>
                    {relationship}
                  </option>
                ))}
              </Select2>
            </div>
            <div className="form-group p-t-0">
              <label htmlFor="firstName" className="text-uppercase">
                First name
              </label>
              <input
                type="text"
                className="form-control"
                id="firstName"
                name="first_name"
                value={beneficiary.first_name || ''}
                aria-required="true"
                required
                onChange={onChange}
              />
            </div>
            <div className="form-group p-t-0">
              <label htmlFor="lastName" className="text-uppercase">
                Last name
              </label>
              <input
                type="text"
                className="form-control"
                id="lastName"
                name="last_name"
                value={beneficiary.last_name || ''}
                aria-required="true"
                required
                onChange={onChange}
              />
            </div>
            <div className="form-group p-t-0">
              <label htmlFor="email" className="text-uppercase">
                Email
              </label>
              <input
                type="email"
                className="form-control"
                id="email"
                name="email"
                value={beneficiary.email || ''}
                aria-required="true"
                required
                onChange={onChange}
              />
            </div>
            <div className="form-group p-t-0">
              <label htmlFor="phone" className="text-uppercase">
                Phone
              </label>
              <Cleave
                id="phone"
                className="form-control"
                name="phone_number"
                required
                options={{
                  blocks: [3, 3, 4],
                  delimiter: '-',
                  numericOnly: true,
                }}
                value={beneficiary.phone_number || ''}
                onChange={onChange}
                onInit={this.handlePhoneInit}
              />
            </div>
          </div>
        </div>
        <div className="form-group row">
          <label className="col-md-3 text-uppercase">Mailing address</label>
          <div className="col-md-9 p-l-30">
            <AddressForm address={beneficiary.address} onChange={onChange} />
          </div>
        </div>
      </Fragment>
    );
  }
}

BeneficiaryForm.propTypes = propTypes;

export default BeneficiaryForm;
